import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Homepage from "./customer/Homepage.js";
import Aboutpage from "./customer/Aboutpage.js";
import Coursespage from "./customer/Coursespage.js";
import Programpage from "./customer/Programpage.js";
import Alumnipage from "./customer/Alumnipage.js";
import Contactus from "./customer/Contactus.js";
import NavbarUser from "./components/NavbarUser.js";
import FooterUser from "./components/FooterUser.js";
import RegisterMonthly from "./components/RegisterMonthly.js";
import RegisterYearly from "./components/RegisterYearly.js";
import ScrollToTop from "./components/ScrollToTop.js";
import UnderMaintenance from "./components/UnderMaintenance.js";
import LoginAdmin from "./admin/LoginAdmin.js";
import DashboardAdmin from "./admin/DashboardAdmin.js";
import StudentDataPage from "./admin/StudentDataPage.js";
import EditStudentPage from "./admin/EditStudentPage.js";
import AddStudentPage from "./admin/AddStudentPage.js";
import ApprovalPage from "./admin/ApprovalPage.js";
import BannerPage from "./admin/BannerPage.js";
import SpecialRegPage from "./admin/SpecialRegPage.js";
import ClassSchedulePage from "./admin/ClassSchedulePage.js";
import ScholarshipAdminPage from "./admin/ScholarshipAdminPage.js";
import InstallmentPage from "./admin/InstallmentPage.js";
import FinancialReportPage from "./admin/FinancialReportPage.js";
import PendingPaymentsPage from "./admin/PendingPaymentsPage.js";
import StudentPackagePage from "./admin/studentPackage/StudentPackagePage.js";
import PaymentAllocationSimulator from "./admin/paymentSimulator/PaymentAllocationSimulator.jsx";
import ScholarshipInfoPage from "./customer/ScholarshipInfoPage.js";
import ApplyScholarship from "./components/ApplyScholarship.js";
import SidebarAdmin from "./components/SidebarAdmin.js";
import SidebarAttendance from "./components/SidebarAttendance.js";
import AttendanceDashboard from "./admin/attendance/AttendanceDashboard.js";
import ClassSessionsPage from "./admin/attendance/ClassSessionsPage.js";
import RfidMappingPage from "./admin/attendance/RfidMappingPage.js";
import { SHOW_RFID_MAPPING } from "./config/attendanceFeatures.js";
import AttendanceGridPage from "./admin/attendance/AttendanceGridPage.js";
import AssignmentGradingPage from "./admin/attendance/AssignmentGradingPage.js";
import ReportPage from "./admin/attendance/ReportPage.js";
import ClassAssistantsPage from "./admin/attendance/ClassAssistantsPage.js";
import CatchupVideosPage from "./admin/attendance/CatchupVideosPage.js";
import SidebarAssistant from "./components/SidebarAssistant.js";
import LoginAssistant from "./assistant/LoginAssistant.js";
import ForgotPassAssistant from "./assistant/ForgotPassAssistant.js";
import PortalLogin from "./portal/PortalLogin.js";
import PortalPassword from "./portal/PortalPassword.js";
import StudentPortal from "./portal/StudentPortal.js";
import RegisterMasterclass from "./components/RegisterMasterclass.js";
import RegisterConference from "./components/RegisterConference.js";
import RegisterOpenClass from "./components/RegisterOpenClass.js";
import RegisterOrientation from "./components/RegisterOrientation.js";
import RegisterGraduation from "./components/RegisterGraduation.js";
import CeaToChurch from "./components/CeaToChurch.js";
import PaymentSuccessPage from "./components/PaymentSuccessPage.js";
import PaymentFailedPage from "./components/PaymentFailedPage.js";
import CancelRegistration from "./components/CancelRegistration.js";
import ResendPayment from "./components/ResendPayment.js";
import PayRedirect from "./components/PayRedirect.js";
import DashboardStudent from "./studentportal/DashboardStudent.js";
import ProfilePageStudent from "./studentportal/ProfilePage.js";
import SidebarStudent from "./components/SidebarStudent.js";
import NavbarStudent from "./components/NavbarStudent.js";
import { useEffect, useState } from "react";

if (process.env.REACT_APP_API_URL) {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
}
axios.defaults.withCredentials = true;

const BASE_CLASSES = [
  { code: "OT",   name: "Old Testament Survey",                        defaultDate: "8-12 Sept",          desc: "An overview study of the context and content of the 39 books of the Old Testament." },
  { code: "NT",   name: "New Testament Survey",                        defaultDate: "29-3 Oct",           desc: "An overview study of the context and content of the 27 books of the New Testament." },
  { code: "BD",   name: "Basic Doctrine",                              defaultDate: "3-7 Nov",            desc: "A biblical study of various core doctrines of Christianity with the goal to produce a healthy framework of thinking in dealing with such." },
  { code: "BLC",  name: "Biblical Leadership and Communication",       defaultDate: "1-5 Dec",            desc: "A study of the biblical patterns an princicples of leadership and communication." },
  { code: "BCMF", name: "Biblical Counseling + Marriage and Family",   defaultDate: "12-16 Jan",          desc: "A biblical study for various marriage and family issues, along with the biblical application of counseling ministry." },
  { code: "MASTERCLASS", name: "Masterclass",                          defaultDate: "Feb",                desc: "An intensive masterclass session led by experienced ministers and practitioners." },
  { code: "HH",   name: "Hermeneutic and Homiletic",                   defaultDate: "25-27 + 30-31 Mar",  desc: "A basic training on how to study, interpret, and deliver the Word of God in a relevant way to various congregations." },
  { code: "CBH",  name: "Church in The Bible and History",             defaultDate: "13-17 Apr",          desc: "Lessons learned and applications for today taken from studying the lives of church both biblically and historically." },
  { code: "CBD",  name: "Covenants and Biblical Discipleship",         defaultDate: "4-8 May",            desc: "A biblical study on God’s terms and conditions in relating with man, with the application of discipleship between man and others." },
  { code: "BWG",  name: "Biblical Worship and Gatherings",             defaultDate: "1-5 June",           desc: "A study on the biblical patterns and principles of worship and church gatherings, with practical applications for today." },
  { code: "MMM",  name: "Mission and Marketplace Ministry",            defaultDate: "20-24 July",         desc: "A study of mission and marketplace ministry from the people who have been in the field of outward ministry." },
  { code: "CONFERENCE", name: "Conference",                            defaultDate: "Aug",                desc: "An annual conference gathering for all CEA students and alumni." },
];

// Guard untuk form pendaftaran yang bisa dibuka/ditutup admin.
// `closed` masih null selama status belum termuat — jangan render form dulu
// supaya form tidak sempat berkedip sebelum dialihkan.
const RegistrationRoute = ({ closed, redirectTo, children }) => {
  if (closed === null) return null;
  if (closed) return <Navigate to={redirectTo} replace />;
  return children;
};

function App() {
  const [location, setLocation] = useState("");
  const [locationAdmin, setLocationAdmin] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767.99);
  const [isMobileAdmin, setIsMobileAdmin] = useState(
    window.innerWidth <= 991.98,
  );
  const [scheduleMap, setScheduleMap] = useState({});
  // null = status belum termuat. Diatur dari Dashboard Admin.
  const [formStatus, setFormStatus] = useState(null);

  const classDetails = BASE_CLASSES.map((c) => {
    const effectiveName = scheduleMap[c.code]?.name || c.name;
    const effectiveDate = scheduleMap[c.code]?.dateText || c.defaultDate;
    return {
      ...c,
      name: effectiveName,
      className: `${effectiveName} | ${effectiveDate}`,
    };
  });

  const publicClassDetails = classDetails.filter(
    (c) => c.code !== "MASTERCLASS" && c.code !== "CONFERENCE",
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767.99);
      setIsMobileAdmin(window.innerWidth <= 991.98);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    axios.get("/config/formstatus")
      .then((res) => setFormStatus(res.data))
      // Kalau status gagal diambil, biarkan form terbuka daripada mengunci user.
      .catch(() =>
        setFormStatus({
          yearly: false,
          monthly: false,
          scholarship: false,
          yearlySpecial: false,
          monthlySpecial: false,
          ceaToChurch: false,
          // Early Registration tertutup secara default (sama seperti backend).
          yearlyEarly: true,
        }),
      );
  }, []);

  useEffect(() => {
    axios.get("/classschedules")
      .then((res) => {
        const map = {};
        res.data.forEach((s) => { map[s.code] = { dateText: s.dateText, name: s.className || "" }; });
        setScheduleMap(map);
      })
      .catch(() => {});
  }, []);

  return (
    <div style={{ backgroundColor: "white" }}>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* ADMIN */}
          <Route exact path="/loginadmin" element={<LoginAdmin />} />
          <Route
            exact
            path="/dashboardadmin"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <DashboardAdmin setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/studentdatapage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <StudentDataPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/addstudent"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <AddStudentPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/studentdatapage/:id"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <EditStudentPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/approvalpage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <ApprovalPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/bannerpage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <BannerPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/specialregpage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <SpecialRegPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/classschedulepage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <ClassSchedulePage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/scholarshipadminpage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <ScholarshipAdminPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/installmentpage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <InstallmentPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/financialreport"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <FinancialReportPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/studentpackage"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <StudentPackagePage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/pendingpayments"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <PendingPaymentsPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/payment-allocation-simulator"
            element={
              <>
                <SidebarAdmin
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <PaymentAllocationSimulator setLocationAdmin={setLocationAdmin} />
              </>
            }
          />

          {/* ATTENDANCE & GRADING (dashboard admin terpisah, lihat tombol
              "Switch to Attendance"/"Switch to Main" di masing-masing sidebar) */}
          <Route
            exact
            path="/attendance/dashboard"
            element={
              <>
                <SidebarAttendance
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <AttendanceDashboard setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/attendance/sessions"
            element={
              <>
                <SidebarAttendance
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <ClassSessionsPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          {/* Route-nya tetap terdaftar meski fiturnya disembunyikan: aplikasi ini
              tidak punya route catch-all, jadi kalau baris ini dihapus URL lama
              yang masih di-bookmark admin akan menghasilkan halaman kosong. */}
          <Route
            exact
            path="/attendance/rfid-mapping"
            element={
              SHOW_RFID_MAPPING ? (
                <>
                  <SidebarAttendance
                    locationAdmin={locationAdmin}
                    isMobileAdmin={isMobileAdmin}
                  />
                  <RfidMappingPage setLocationAdmin={setLocationAdmin} />
                </>
              ) : (
                <Navigate to="/attendance/dashboard" replace />
              )
            }
          />
          <Route
            exact
            path="/attendance/grid"
            element={
              <>
                <SidebarAttendance
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <AttendanceGridPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/attendance/grading"
            element={
              <>
                <SidebarAttendance
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <AssignmentGradingPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/attendance/report"
            element={
              <>
                <SidebarAttendance
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <ReportPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />
          <Route
            exact
            path="/attendance/catchup"
            element={
              <>
                <SidebarAttendance
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <CatchupVideosPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />

          <Route
            exact
            path="/attendance/assistants"
            element={
              <>
                <SidebarAttendance
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <ClassAssistantsPage setLocationAdmin={setLocationAdmin} />
              </>
            }
          />

          {/* CLASS ASSISTANT PORTAL — halaman yang sama dengan dashboard
              Attendance, tapi hanya Class Sessions dan Attendance Grid, dengan
              login sendiri. */}
          <Route exact path="/assistant/login" element={<LoginAssistant />} />
          <Route exact path="/assistant/forgot-password" element={<ForgotPassAssistant />} />
          <Route exact path="/assistant" element={<Navigate to="/assistant/sessions" replace />} />
          <Route
            exact
            path="/assistant/sessions"
            element={
              <>
                <SidebarAssistant
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <ClassSessionsPage setLocationAdmin={setLocationAdmin} assistant />
              </>
            }
          />
          <Route
            exact
            path="/assistant/grid"
            element={
              <>
                <SidebarAssistant
                  locationAdmin={locationAdmin}
                  isMobileAdmin={isMobileAdmin}
                />
                <AttendanceGridPage setLocationAdmin={setLocationAdmin} assistant />
              </>
            }
          />

          {/* STUDENT PORTAL */}

          {/* Portal student yang baru. Halamannya di /portal/..., bukan
              /student/...: GET /student/:id sudah dipakai API admin, jadi
              halaman di bawah /student/ akan tertangkap route itu saat
              di-refresh. /portal/:view dipakai untuk dashboard, classes, dan
              profile sekaligus supaya datanya tidak diambil ulang tiap pindah
              menu. */}
          <Route exact path="/portal" element={<Navigate to="/portal/dashboard" replace />} />
          <Route exact path="/portal/login" element={<PortalLogin />} />
          <Route exact path="/portal/password" element={<PortalPassword />} />
          <Route exact path="/portal/:view" element={<StudentPortal />} />

          {/* Alamat login lama dialihkan ke portal baru. */}
          <Route exact path="/loginstudent" element={<Navigate to="/portal/login" replace />} />

          <Route
            exact
            path="/profilepage"
            element={
              <>
                {/* <NavbarStudent /> */}
                <SidebarStudent />
                <ProfilePageStudent />
              </>
            }
          />

          <Route
            exact
            path="/editprofile"
            element={
              <>
                {/* <NavbarStudent /> */}
                <SidebarStudent />
                <DashboardStudent />
              </>
            }
          />

          {/* Halaman buat/lupa password lama memanggil endpoint yang sudah
              dicabut (password bisa diganti tanpa OTP) — keduanya dialihkan
              ke alur OTP portal baru. */}
          <Route exact path="/setpassword" element={<Navigate to="/portal/password?mode=create" replace />} />
          <Route exact path="/forgotpassword" element={<Navigate to="/portal/password?mode=forgot" replace />} />

          {/* USER */}
          {/* <Route exact path="/" element={<UnderMaintenance />} /> */}
          <Route
            exact
            path="/"
            element={
              <>
                <NavbarUser location={location} isMobile={isMobile} />
                <Homepage
                  setLocation={setLocation}
                  classDetails={publicClassDetails}
                />
                <FooterUser location={location} />
              </>
            }
          />
          <Route
            exact
            path="/about"
            element={
              <>
                <NavbarUser location={location} isMobile={isMobile} />
                <Aboutpage setLocation={setLocation} />
                <FooterUser location={location} />
              </>
            }
          />
          <Route
            exact
            path="/courses"
            element={
              <>
                <NavbarUser location={location} isMobile={isMobile} />
                <Coursespage
                  setLocation={setLocation}
                  classDetails={publicClassDetails}
                />
                <FooterUser location={location} />
              </>
            }
          />
          <Route
            exact
            path="/programs"
            element={
              <>
                <NavbarUser location={location} isMobile={isMobile} />
                <Programpage setLocation={setLocation} formStatus={formStatus} />
                <FooterUser location={location} />
              </>
            }
          />
          <Route
            exact
            path="/alumni"
            element={
              <>
                <NavbarUser location={location} isMobile={isMobile} />
                <Alumnipage setLocation={setLocation} />
                <FooterUser location={location} />
              </>
            }
          />
          <Route
            exact
            path="/contactus"
            element={
              <>
                <NavbarUser location={location} isMobile={isMobile} />
                <Contactus setLocation={setLocation} />
                <FooterUser location={location} />
              </>
            }
          />
          <Route
            exact
            path="/scholarshipinfo"
            element={
              <>
                <NavbarUser location={location} isMobile={isMobile} />
                <ScholarshipInfoPage setLocation={setLocation} formStatus={formStatus} />
                <FooterUser location={location} />
              </>
            }
          />
          <Route
            exact
            path="/applyscholarship"
            element={
              <RegistrationRoute
                closed={formStatus === null ? null : formStatus.scholarship}
                redirectTo="/scholarshipinfo"
              >
                <ApplyScholarship classDetails={classDetails} />
              </RegistrationRoute>
            }
          />
          <Route
            exact
            path="/registermonthly"
            element={
              <RegistrationRoute
                closed={formStatus === null ? null : formStatus.monthly}
                redirectTo="/programs"
              >
                <RegisterMonthly classDetails={classDetails} />
              </RegistrationRoute>
            }
          />
          <Route
            exact
            path="/registermonthlyspecial"
            element={
              <RegistrationRoute
                closed={formStatus === null ? null : formStatus.monthlySpecial}
                redirectTo="/programs"
              >
                <RegisterMonthly classDetails={classDetails} requiresApproval />
              </RegistrationRoute>
            }
          />
          <Route exact path="/registermasterclass" element={<RegisterMasterclass />} />
          <Route exact path="/registerconference" element={<RegisterConference />} />
          <Route exact path="/registeropenclass" element={<RegisterOpenClass />} />
          <Route exact path="/openclassforchurches" element={<RegisterOpenClass invitation />} />
          <Route exact path="/registerorientation" element={<RegisterOrientation />} />
          <Route exact path="/registergraduation" element={<RegisterGraduation />} />
          <Route
            exact
            path="/registeryearly"
            element={
              <RegistrationRoute
                closed={formStatus === null ? null : formStatus.yearly}
                redirectTo="/programs"
              >
                <RegisterYearly classDetails={classDetails} />
              </RegistrationRoute>
            }
          />
          <Route
            exact
            path="/registeryearlyspecial"
            element={
              <RegistrationRoute
                closed={formStatus === null ? null : formStatus.yearlySpecial}
                redirectTo="/programs"
              >
                <RegisterYearly classDetails={classDetails} requiresApproval />
              </RegistrationRoute>
            }
          />
          {/* Early Registration 1 Year Program untuk batch berikutnya — dibuka
              dari banner "Early Registration" di homepage. */}
          <Route
            exact
            path="/earlyregistration"
            element={
              <RegistrationRoute
                closed={formStatus === null ? null : formStatus.yearlyEarly}
                redirectTo="/programs"
              >
                <RegisterYearly classDetails={classDetails} earlyRegistration />
              </RegistrationRoute>
            }
          />
          {/* Hidden route — link dibagikan langsung ke gereja, tidak ada di navbar */}
          <Route
            exact
            path="/ceatochurch"
            element={
              <RegistrationRoute
                closed={formStatus === null ? null : formStatus.ceaToChurch}
                redirectTo="/programs"
              >
                <CeaToChurch classDetails={classDetails} />
              </RegistrationRoute>
            }
          />
          {/* Midtrans finish/error redirect URL — tidak ada di navbar */}
          <Route exact path="/paymentsuccess" element={<PaymentSuccessPage />} />
          <Route exact path="/paymentfailed" element={<PaymentFailedPage />} />
          <Route exact path="/cancel-registration/:orderId" element={<CancelRegistration />} />
          <Route exact path="/resend-payment/:orderId" element={<ResendPayment />} />
          <Route exact path="/pay/:orderId" element={<PayRedirect />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
